import React from 'react';

import './footer.css';

const Footer = () => {
    return(
    <footer>Site criado por <a href="https://sarafogo-portfolio.netlify.app/" target="_blank" rel="noopener noreferrer" className="link-footer">Sara Fogo</a></footer>
    )

}

export default Footer;